import { distanceOrTown } from 'Common/distanceOrTown';

export const dealer = (props = {}) => {
  const valueOrNA = value => value || 'N/A';

  return {
    name: valueOrNA(props.item.dealer.name),
    phone: valueOrNA(props.item.dealer.primary_phone),
    altPhone: props.item.dealer.secondary_phone,
    distanceOrTown: distanceOrTown(props.item),
    logo: valueOrNA(props.item.dealer.logo),
    id: valueOrNA(props.item.dealer.id),
    strapline:
      'Lorem ipsum dolor sit amet, timeam sapientem dissentiunt nec ad. Vix possit petentium ad. In facer viderer reprehendunt pri, oportere deterruisset duo te'
  };
};



// WEBPACK FOOTER //
// ./src/Common/dealer/index.js